import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  MapPrivacySelectorModalContainer, type MapPrivacySelectorModalContainerProps,
} from './mapPrivacySelectorModal.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    MapPrivacySelector: MapPrivacySelectorModalContainerProps;
  }
}

modalRenderer.register('MapPrivacySelector', MapPrivacySelectorModalContainer);
